import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
// import faker from 'faker';
import datass from './gradingstats.json';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export function ChartForStats({ finalStudentCount }) {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  // console.log('finalStudentCountfinalStudentCount', finalStudentCount);

  let labledata = [];
  let noOfStudent = [];

  finalStudentCount.map((item) => {
    return labledata.push(item.GradeLetter);
  });

  finalStudentCount.map((item) => {
    return noOfStudent.push(item.NumberOfStudent);
  });

  const labels = labledata;
  // ['A+', 'A-', 'A', 'B', 'B-'];

  const data = {
    labels,
    datasets: [
      {
        fill: true,
        label: '',
        data: noOfStudent,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
      },
    ],
  };

  return <Line options={options} data={data} />;
}
